// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"c13a9d1b","395":"06a84be1","643":"0e02bb73","734":"a484f421","955":"2f482362"}[chunkId] + ".chunk.js";
};